/* upk-journal.js (P9, 19 Oct 2026). Two small jobs on the journal pages, deferred.
   1. The article product rail (sections/upk-article-products) is served as a shell: heading, placeholders and the cards inside
      a <template>, so no card image, script or layout work happens until the rail comes within 600 px of the viewport
      (IntersectionObserver; addendum D, the P7 below-the-fold rule). Then the template content is moved into the scroller and
      the cards behave like any collection card (the quick view and add listeners are delegated on document). With the
      placement "after the first H2" the section has already moved itself into the guide's slot with an inline script; this
      file also does that move for sections re-rendered in the theme editor.
   2. The contents list (sections/main-article): opens on desktop, where it sits beside the text, and marks the heading in view. */
(function () {
  'use strict';
  if (window.__upkJournal) return; window.__upkJournal = 1;

  function fill(rail) {
    if (rail.getAttribute('data-state') === 'filled') return;
    var tpl = rail.querySelector('template[data-upk-arail-tpl]');
    var list = rail.querySelector('.upk-arail__scroller');
    if (!tpl || !list) return;
    list.innerHTML = '';
    list.appendChild(document.importNode(tpl.content, true));
    list.removeAttribute('aria-busy');
    tpl.parentNode.removeChild(tpl);
    rail.setAttribute('data-state', 'filled');
    document.dispatchEvent(new CustomEvent('upk:arail:filled', { detail: { rail: rail } }));
  }
  function place(rail) {
    if (rail.getAttribute('data-placement') !== 'after_first_h2') return;
    var slot = document.querySelector('[data-upk-arail-slot]');
    if (!slot || slot.contains(rail)) return;
    var old = slot.querySelector('.upk-arail');
    if (old) old.parentNode.removeChild(old);
    slot.appendChild(rail);
  }
  function watch(rail) {
    if (rail.__upkWatched) return; rail.__upkWatched = 1;
    place(rail);
    if (!('IntersectionObserver' in window)) { fill(rail); return; }
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) { if (entries[i].isIntersecting) { io.disconnect(); fill(rail); break; } }
    }, { rootMargin: '600px 0px 600px 0px' });
    io.observe(rail);
  }
  function toc() {
    var box = document.querySelector('.upk-toc');
    if (!box || box.__upkToc) return; box.__upkToc = 1;
    var art = box.closest('.upk-art');
    var wide = art && art.classList.contains('upk-art--wide');
    var mq = window.matchMedia(wide ? '(min-width: 1440px)' : '(min-width: 1280px)');
    var sync = function () { if (mq.matches && box.tagName === 'DETAILS') box.open = true; };
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync); else if (mq.addListener) mq.addListener(sync);
    var links = [].slice.call(box.querySelectorAll('a[href^="#"]'));
    var targets = [];
    for (var i = 0; i < links.length; i++) {
      var id = decodeURIComponent(links[i].getAttribute('href').slice(1));
      var t = document.getElementById(id);
      if (t) targets.push(t);
    }
    if (!targets.length || !('IntersectionObserver' in window)) return;
    var active = null;
    var spy = new IntersectionObserver(function (entries) {
      for (var j = 0; j < entries.length; j++) { if (entries[j].isIntersecting) active = entries[j].target; }
      if (!active) return;
      for (var k = 0; k < links.length; k++) { links[k].classList.toggle('is-active', links[k].getAttribute('href') === '#' + active.id); }
    }, { rootMargin: '-15% 0px -70% 0px', threshold: 0 });
    for (var m = 0; m < targets.length; m++) spy.observe(targets[m]);
  }
  function init(root) {
    var rails = (root || document).querySelectorAll('[data-upk-arail]');
    for (var i = 0; i < rails.length; i++) watch(rails[i]);
    toc();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
